import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import _ from 'underscore'
import cookie from '../lib/cookie'

const getSmsCode = data => new Promise((resolve, reject) => {
  const url = CONSTANT.REQUEST_HOST
  data = JSON.stringify(data)

  Api.post(url, data, {
    headers: {
      'X-Host': 'mall.user.sms-code.send',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status !== 0) {
      return reject(data)
    }
    resolve(data.data)
  },
  (e) => {
    reject(e)
  })
})
const getUserInfo = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${CONSTANT.REQUEST_HOST}${query}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.user.info.get',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  },
  (e) => {
    reject(e)
  })
})
const getCaptcha = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${CONSTANT.REQUEST_HOST}${query}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.user.captcha',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  },
  (e) => {
    reject(e)
  })
})
const isFollowedWechat = data => new Promise((resolve, reject) => {
  data = JSON.stringify(data)
  const url = CONSTANT.REQUEST_HOST

  Api.post(url, data, {
    headers: {
      'X-Host': 'mall.wechat.is-subscribed',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  },
  (e) => {
    reject(e)
  })
})
const sendWechatMsgTpl = data => new Promise((resolve, reject) => {
  data = JSON.stringify(data)
  const url = CONSTANT.REQUEST_HOST

  Api.post(url, data, {
    headers: {
      'X-Host': 'mall.wechat.template-msg',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
  .then((data) => {
    if (data.status !== 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  },
  (e) => {
    reject(e)
  })
})

const uploadImage = data => new Promise((resolve, reject) => {
  Api.post(CONSTANT.REQUEST_HOST, data, {
    headers: {
      'X-Host': 'mall.img.upload',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  },
  )
  .then((data) => {
    if (data.status != 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})


const generateActionText = (data) => {
  data = JSON.stringify(data)
  return new Promise((resolve, reject) => {
    Api.post(CONSTANT.REQUEST_HOST, data, {
      headers: {
        'X-Host': 'mall.public.action.generate-text',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
      },
    },
    )
    .then((data) => {
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}
/**
 * 生成在线客服链接地址
 * @param {Object} params
 * @param {number} params.fieldType // 字段类型：1订单号, 2:售后单号
 * @param {string} params.fieldValue // 字段值
 */
const getCustomeUrl = params => new Promise((resolve, reject) => {
  Api.post(CONSTANT.REQUEST_HOST, JSON.stringify(params), {
    headers: {
      'X-Host': 'mall.after-sale.custom-url',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  }).then((res) => {
    if (res.status !== 0) {
      return reject(new Error(res.msg))
    }
    return resolve(res.data)
  }, e => reject(e))
})


/**
 * 媒体文件上传
 * @param {file} data.file 文件
 * @param {number} data.businessType 1.用户  2.售后   3.运营
 * @param {number} data.source 0.同业 1.aura
 * @returns
 */
const uploadMedia = (data = { file: null, businessType: 2, source: 1 }) => new Promise((resolve, reject) => {
  Api.post(CONSTANT.REQUEST_HOST, data, {
    headers: {
      'X-Host': 'mall.media.file.upload',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  },
  )
  .then((data) => {
    if (data.status != 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

/**
 * 分片上传前，获取唯一值
 * @param {number} data.businessType 1.用户  2.售后   3.运营
 * @param {number} data.source 0.同业   1.aura
 * @param {string} data.fileSuffix 后缀名 "mp4"
 */
const getUploadId = data => new Promise((resolve, reject) => {
  let url = CONSTANT.REQUEST_HOST
  // url = 'http://192.168.1.71:8080/api/multi-upload/upload-id'// 'https://yapi.sdyxmall.com/mock/57/api/multi-upload/upload-id'
  Api.get(url, {
  // Api.get(CONSTANT.REQUEST_HOST, {
    params: data,
    headers: {
      'X-Host': 'mall.media.multi-upload.upload-id',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  },
  )
  .then((data) => {
    if (data.status != 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

/**
 * 媒体未见分片上传
 * https://yapi.sdyxmall.com/project/57/interface/api/1905
 * @param {*} data.file 文件片段
 * @returns
 */
const multiUploadMedia = data => new Promise((resolve, reject) => {
  let url = CONSTANT.REQUEST_HOST
  // url = 'http://192.168.1.71:8080/api/multi-upload/upload'
  Api.post(url, data, {
  // Api.post(CONSTANT.REQUEST_HOST, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Host': 'mall.media.multi-upload.upload',
      'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  },
  )
  .then((data) => {
    if (data.status != 0) {
      return reject(data.msg)
    }
    resolve(data.data)
  }, (e) => {
    reject(e)
  })
})

export default {
  getSmsCode,
  getUserInfo,
  getCaptcha,
  isFollowedWechat,
  sendWechatMsgTpl,
  uploadImage,
  generateActionText,
  getCustomeUrl,
  uploadMedia,
  getUploadId,
  multiUploadMedia,
}
